<!-- eslint-disable -->
<template lang="pug">
    .multiplayer-game-menu__selectors
        cs-multiselect.selector.examples-type-selector(
            :multiple="true",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :hide-selected='true',
            :allow-empty="false",
            :max="2",
            label="label",
            :value="selectedExamplesTypes",
            :options="examplesTypes",
            :disabled="gameState === 'started'",
            @select="selectedExamplesTypes.push($event)",
            @remove="removeSelectedExamplesType",
        )
        cs-multiselect.selector.divisible-multiplier-selector(
            multiple,
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier')",
            :allow-empty="false",
            v-model="selectedDivisibleMultiplierValue",
            :options="computedOptions",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                |
        cs-multiselect.selector.players-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="playersAmount",
            :options="players",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_players') }}:
                |
</template>

<script>
    /*eslint-disable*/
    import MultiplayerOptionsMixin from "../../../utils/multiplayer/optionsMixin";
    import { cloneDeep } from "lodash";

    const MULTIPLY_ACTION = 'multiply';
    const DIVIDE_ACTION = 'divide';
    const COMMON_PARAMETERS_CHANGED_EVENT = 'commonParametersHasChanged';

    export default {
        mounted () {
            this.selectedExamplesTypes = this.examplesTypes.filter(type => {
                if (this.commonParams.operations.multiply && this.commonParams.operations.divide) {
                    return true;
                } else if (this.commonParams.operations.multiply) {
                    return type.action === MULTIPLY_ACTION;
                } else if (this.commonParams.operations.divide) {
                    return type.action === DIVIDE_ACTION;
                }
                return false;
            });
            this.selectedDivisibleMultiplierValue = this.commonParams.numbers;
            //set first multiselect tags to be in one height with another
            let examplesTypeMultiselectTags = document.querySelector('.multiselect__tags');
            if (examplesTypeMultiselectTags) {
                examplesTypeMultiselectTags.style.cssText = 'padding: 8px 15px';
            }
        },
        mixins: [MultiplayerOptionsMixin],
        watch: {
            selectedExamplesTypes: {
                handler (value, oldValue) {
                    if (value) {
                        if (!value.some(type => type.action === MULTIPLY_ACTION)) {
                            this.commonParams.operations[MULTIPLY_ACTION] = false;
                        }
                        if (!value.some(type => type.action === DIVIDE_ACTION)) {
                            this.commonParams.operations[DIVIDE_ACTION] = false;
                        }

                        if (value.some(type => type.action === DIVIDE_ACTION)) {
                            this.selectedDivisibleMultiplierValue = this.commonParams.numbers.filter(el => el !== 0);
                            this.commonParams.numbers = this.commonParams.numbers.filter(el => el !== 0);
                            this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                name: 'numbers',
                                value: this.commonParams.numbers,
                            });
                        }
                        value.forEach(type => this.commonParams.operations[type.action] = true);
                        if (oldValue !== null) {
                            this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                setOperationsValues: true,
                                names: [MULTIPLY_ACTION, DIVIDE_ACTION],
                                values: [
                                    this.commonParams.operations[MULTIPLY_ACTION],
                                    this.commonParams.operations[DIVIDE_ACTION]
                                ]
                            });
                        }
                    }
                },
                immediate: true
            },
            selectedDivisibleMultiplierValue: {
                handler (value, oldValue) {
                    if (value) {
                        if (this.commonParams?.numbers) {
                            this.commonParams.numbers = value;
                            if (oldValue?.length) {
                                this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                                    name: 'numbers',
                                    value: this.commonParams.numbers,
                                });
                            }
                        }
                    }
                },
                immediate: true
            },
        },
        data () {
            return {
                selectedExamplesTypes: null,
                examplesTypes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_multiplication'),
                        action: MULTIPLY_ACTION,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_division'),
                        action: DIVIDE_ACTION,
                    }
                ],
                selectedDivisibleMultiplierValue: [],
                difficultyOptions: [...Array(11).keys()]
            }
        },
        computed: {
            computedOptions() {
                if (this.commonParams?.operations?.divide) {

                    return [...Array(11).keys()].splice(1, 10);
                }
                return [...Array(11).keys()];
            }
        },
        methods: {
            removeSelectedExamplesType (removedType) {
                this.selectedExamplesTypes = this.selectedExamplesTypes.filter(type => type.action !== removedType.action);
            }
        },
    }
</script>

<style scoped lang="scss">
    .multiplayer-game-menu__selectors {
        display: flex;
        width: 80%;
        margin: 20px;
    }
    .selector {
        margin: 0 10px;
        max-height: 44px;
        &:first-child {
            margin-left: 0;
        }
        @media screen and (max-width: 1439px) {
            max-width: 175px;
        }
    }
</style>